import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const Button = styled.button`
  display: flex;
  flex: 1;
  min-height: 40px;
  font-size: 13px;
  justify-content: center;
  align-items: center;
  background: #f6f6f6;
  border: 2px solid #f6f6f6;
  outline: 0;
  cursor: pointer;
`;

export const Content = styled.div<{ flushBottom?: boolean }>`
  flex: 1;
  max-height: 0px;
  border-width: 0px;
  border-color: #f6f6f6;
  border-style: solid;
  overflow: hidden;
  transition: max-height 500ms, border-width 500ms;
  &.active {
    max-height: 100vh;
    border-width: ${(props) => (props.flushBottom ? '2px 2px 0' : '2px')};
    transition: max-height 500ms;
  }
`;
